import React, { useContext, useEffect, useRef, useState } from "react";
import "../../../assets/styles/topbar.scss";
import { Navbar } from "react-bootstrap";
import { IconBell, IconCalendar, IconConfig } from "../../../icons/Icon";
import SmuBadge from "../../../utils/smu-badge/SmuBadge";
import SmuSearch from "../../../utils/smu-search/SmuSearch";
import { COLOR_PRIMARY } from "../../../constants/colors";
import CalendarItem from "../parts/CalendarItem";
import SmuPopupTb from "../parts/SmuPopupTb";
import NtfItem from "../parts/NtfItem";
import SmuProfile from "../../../utils/smu-profile/SmuProfile";
import { StoreContext } from "../../../store/StoreContext";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import defaultAvatar from "../../../assets/images/user_default.png";
import { getSearch } from "../../../api/search";

const Topbar = () => {
  
  const popoverRef = useRef(null);
  const navigate = useNavigate();
  const {
    loggedUser,
    isAdmin,
    alerts,
    promotions,
    setSearchResult,
    setSearching,
    searching,
    serach,
    setSearch,
  } = useContext(StoreContext);

  const menu = [
    {
      id: 1,
      title: "Ir al Admin",
      path: "/promotional-portal/admin/",
      Icon: <IconConfig color="#33383F" />,
    },
  ];

  const [openCalendar, setOpenCalendar] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [targetC, setTargetC] = useState(null);
  const [targetN, setTargetN] = useState(null);
  const [calendarItems, setCalendarItems] = useState([]);

  useEffect(() => {
    let _calendarItems = _.orderBy(promotions, ["FECHA_INICIO"], ["desc"]);
    _calendarItems = _.take(_calendarItems, 4);
    setCalendarItems(_calendarItems);
  }, [promotions]);

  const handleOpenCalendar = (event) => {
    setOpenCalendar((val) => !val);
    setTargetC(event.target);
  };

  const handleOpenNotifications = (event) => {
    setOpenNotifications((val) => !val);
    setTargetN(event.target);
  };

  const goToCalendar = () => {
    setOpenCalendar(false);
    navigate("calendar");
  };

  const goToAllNotifications = () => {
    setOpenNotifications(false);
    navigate("notifications");
  };

  const handleSearch = (val) => {
    if (searching) return;
    
    const searchValue = val || "";
    setSearch(searchValue);

    const path = window.location.pathname.toLowerCase();
    if (path.includes("portal") && path.includes("skirt")) {
      navigate("seeker", { state: { filter: "skirt" } });
    } else if (path.includes("portal") && path.includes("promotions")) {
      navigate("seeker", { state: { filter: "promotions" } });
    } else {
      navigate("seeker");
    }
    setSearching(true);
    getSearch(searchValue)
      .then((result) => {
        const _result = _.get(result, "data.O_ARTICULOS", []);
        setSearchResult(Array.isArray(_result) ? _result : []);
      })
      .catch((error) => {
        console.error("Error searching:", error);
        setSearchResult([]);
      })
      .finally(() => {
        setSearching(false);
      });
  };

  return (
    <Navbar bg="white" className="topbar-general" ref={popoverRef}>
      <div className="d-flex mx-lg-4 w-100">
        <div className="d-flex my-auto h-100 pe-lg-4">
          <SmuBadge _className="rounded my-auto" color={COLOR_PRIMARY} />
          <div className="fs-5 ms-3 smu-text-darker text-truncate">
            Portal Promocional
          </div>
        </div>

        <SmuSearch
          _className="my-auto ms-5 me-auto w-100"
          action={handleSearch}
          value={serach}
          placeholder="Buscar promociones y faldones"
          onChange={(event) => setSearch(event.target.value)}
        />

        <div className="divider" />

        <div className="d-flex px-lg-3 mx-4">
          <button
            type="button"
            className="smu-generic-button my-auto py-1 fs-6 px-3 d-flex align-items-center"
            onClick={(event) => handleOpenCalendar(event)}
          >
            <IconCalendar color={COLOR_PRIMARY} />
            <span className="text-truncate ms-2 d-none d-lg-flex">
              Calendario
            </span>
          </button>

          <SmuPopupTb
            badgeColor="#83BF6E"
            open={openCalendar}
            target={targetC}
            popoverRef={popoverRef}
            title="Actividades Calendario"
            all={goToCalendar}
          >
            {calendarItems.map((item) => (
              <CalendarItem key={item.ID_PROMO} item={item} />
            ))}
          </SmuPopupTb>
        </div>

        <div className="divider" />

        <div className="d-flex mx-2 my-auto">
          <button
            type="button"
            className="btn-notifications"
            onClick={(event) => handleOpenNotifications(event)}
          >
            {alerts.length > 0 && <span className="pin" />}
            <IconBell color="#6F767E" />
          </button>

          <SmuPopupTb
            badgeColor="#FF6A55"
            open={openNotifications}
            target={targetN}
            popoverRef={popoverRef}
            title="Notificaciones"
            all={() => goToAllNotifications()}
            noData={alerts.length < 1}
          >
            {alerts.map((item, index) => (
              <NtfItem key={index} item={item} />
            ))}
          </SmuPopupTb>
        </div>

        <div className="divider" />
        <SmuProfile
          avatar={loggedUser?.avatar || defaultAvatar}
          name={loggedUser?.name || loggedUser?.username}
          menu={menu}
          isAdmin={isAdmin}
        />
      </div>
    </Navbar>
  );
};

export default Topbar;
